package com.fireavert.events.reboot_devices.client.presentation

class RebootDeviceDialogController(
    private val interactor: RebootDevice
) {
    fun close(propertyId: Int) = interactor.close(propertyId)
    suspend fun clickedRebootDevice(deviceId: Int) = interactor.rebootDevice(deviceId)
}